import {
  Sort_Field,
  Sort_Order,
  type EntityPagerSorting,
} from "@/graphql/generated-types";
import type { TimeBasedEvent } from "@/types";
import { isAfter, isBefore } from "date-fns";

const selectDateComparator = (order: Sort_Order) => {
  return order === Sort_Order.Asc ? isAfter : isBefore;
};

const createDateAccessor = (field: Sort_Field) => (item: unknown) => {
  const event = item as unknown as TimeBasedEvent;

  if (field === Sort_Field.StartDate) {
    return new Date(event.startDate);
  }

  if (field === Sort_Field.EndDate) {
    return new Date(event.endDate);
  }

  throw new Error(`Undefined sorting type: ${field}`);
};

export default (sorting: EntityPagerSorting) => {
  return {
    comparator: selectDateComparator(sorting.order),
    accessor: createDateAccessor(sorting.field),
  };
};
